import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import { Link } from 'react-router-dom';



export class AddNew_DisplayColosysProductLocation extends Component {
    static displayName = AddNew_DisplayColosysProductLocation.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            loading: false,
            alertMessage: "",
            colosysProductLocations: [],
            selectedStocktake: "",
            selectedProductId: props.location.state.selectedProductId,
            selectedStocktake: "",
            selectedProductId: props.location.state.selectedProductId,
            selectedProductCode: "",
            selectedLocationId: props.location.state.selectedLocationId,
            selectedLocationBarcode: props.location.state.selectedLocationBarcode,
            previouspage: props.location.state.previouspage,
            isBlind: props.location.state.isBlind
    
        }
    }

    componentDidMount() {

        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.clearAll("Please select a Stocktake");
            return;
        }

        this.loadColosysProductLocations();

    }
 

    async loadColosysProductLocations() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetColosysProductLocations?stocktakeId=${this.state.selectedStocktake.stocktakeId}&productId=${this.state.selectedProductId}&isBlind=${this.state.isBlind}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ colosysProductLocations: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                  

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ colosysProductLocations: data, alertMessage: "" });
                        }
                        else {
                            this.setState({
                                alertMessage: "No locations found" });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load locations!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ colosysProductLocations: [], alertMessage: error });
            });
    }




    render() {
  

        let loadingHtml = this.state.loading
            ? <p><em>Loading product locations...</em></p>
            : "";

        let productLocationsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderLocations();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";


        return (
            <div>
                <Container>
                    <Row>
                        <Col xs={9}><h5>Add Extra - Colosys Location</h5></Col>
                        <Col xs={3}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AddNew_ProductCount", state: this.state }}>Back</Link>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}> {loadingHtml}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            {productLocationsHtml}
                        </Col>

                    </Row>
                </Container>
            </div>

        );
    }

    renderLocations() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Location</label>
                            </th>
                            <th className="col-sm-4">
                                <label>Qty</label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.colosysProductLocations
                            .map(row =>
                                <tr key={row.rowId} >
                                    <td>{row.location}</td>
                                    <td>{row.qty}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}